import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import {
    Box,
    Typography,
    Paper,
    Container,
    Alert,
    CircularProgress,
    Button,
} from '@mui/material';
import axios from 'axios';
import { internshipDomain } from '../util/domain';

const Certificate = () => {
    const { certificateId } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [certificateData, setCertificateData] = useState(null);

    useEffect(() => {
        const fetchCertificateData = async () => {
            try {
                const response = await axios.get(`${internshipDomain}/api/certificate/verify/${certificateId}`);
                if (response.data.success) {
                    setCertificateData(response.data.certificate);
                }
            } catch (error) {
                setError('Failed to fetch certificate details');
            } finally {
                setLoading(false);
            }
        };

        fetchCertificateData();
    }, [certificateId]);

    const handleDownload = () => {
        // In a real application, this would generate and download a PDF
        window.print();
    };

    if (loading) {
        return (
            <Container maxWidth="md">
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="md">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Certificate of Completion
                </Typography>

                {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

                {certificateData && (
                    <Box sx={{ mb: 3 }}>
                        <Box sx={{
                            border: '4px solid #1976d2',
                            borderRadius: 2,
                            p: 6,
                            mb: 3,
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(45deg, #f3f3f3 25%, transparent 25%, transparent 75%, #f3f3f3 75%, #f3f3f3)',
                            backgroundSize: '20px 20px',
                            position: 'relative'
                        }}>
                            <Typography variant="h3" gutterBottom sx={{ fontFamily: 'serif' }}>
                                Certificate of Completion
                            </Typography>

                            <Typography variant="h6" gutterBottom sx={{ mt: 4 }}>
                                This is to certify that
                            </Typography>

                            <Typography variant="h4" gutterBottom sx={{
                                color: '#1976d2',
                                fontFamily: 'serif',
                                my: 3
                            }}>
                                {certificateData.name}
                            </Typography>

                            <Typography variant="h6" gutterBottom>
                                from
                            </Typography>

                            <Typography variant="h5" gutterBottom sx={{ mb: 4 }}>
                                {certificateData.college_name}
                            </Typography>

                            <Typography variant="body1" paragraph>
                                has successfully completed the Vector India Workshop
                            </Typography>

                            <Typography variant="body2" color="textSecondary" sx={{ mt: 4 }}>
                                Certificate ID: {certificateId}
                            </Typography>

                            <Typography variant="body2" color="textSecondary">
                                Issue Date: {new Date(certificateData.issue_date).toLocaleDateString()}
                            </Typography>
                        </Box>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleDownload}
                            sx={{ mt: 2 }}
                        >
                            Download Certificate
                        </Button>
                    </Box>
                )}
            </Paper>
        </Container>
    );
};

export default Certificate; 